<script>
    import { onMount, tick } from 'svelte';
    export let lang, dataset;
    
    import Portal from 'svelte-portal';

    import ReviewPDP from './ReviewsPdpSection.svelte'
    import ReviewDialog from './Reviews.svelte';
    import QuestionsDialog from './Questions.svelte';
    import Reviews from './Reviews.svelte';
    import {scrollToElement} from './util.js';
    import ReviewPanel from './ReviewPanel.svelte'

    import './authDialogStyles.css';

    const en = lang == 'en';
    const productCode = dataset.productCode;
    const product = JSON.parse(dataset.product);
    let panelType = ''
    let panelIsOpen = false;

    //let dialogEle

    const Strings = en ? {
        ratingsAndReviews: 'Ratings and Reviews',
        questionsAndAnswers: 'Questions and Answers',
        close: 'Close',
    } : {
        ratingsAndReviews: 'Notes et avis',
        questionsAndAnswers: 'Questions et réponses',
        close: 'Fermer',
    };

    //let getModalCookie = false
    let getModalType = false
    let bvOriginalUrl = false
    let submitReviewDialogEle;
    let submitReviewProductCode;
    let checkedRatingVal;

    onMount(async()=> {
        try {
            //check modal cookies after review submit
            //getModalCookie = getCookie('BV_modal_type')
            //bvOriginalUrl = getCookie('BV_req_url')
            let urlParams = new URLSearchParams(window.location.search);
            getModalType = urlParams.get('bv_modal')

            if(urlParams.get('BV_user_id')){
                //Set BV_user_id cookie for 30 days
                document.cookie = `BV_user_id=${urlParams.get('BV_user_id')}; path=/; max-age=${60 * 60 * 24 * 365}`;

            }
    
            if(getModalType) {
                // Wait for DOM to render the dialog
                await tick();
                submitReviewDialogEle.showModal()
                submitReviewDialogEle.focus()
                submitReviewDialogEle.blur()
            }
    
            /** delete BV_modal_type cookie*/
            //document.cookie = "BV_modal_type=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            //document.cookie = "bvOriginalUrl=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            urlParams.delete('bv_modal')
            urlParams.delete('BV_user_id')
            window.history.replaceState({}, document.title, `${window.location.pathname}?${urlParams.toString()}`);

            
        } catch (error) {
            console.log('Error occured on mount', error)
        }

    })

    function openDialog(type) {
        panelType = type;

        if(panelType == 'reviews') {
            const reviewAccordionEle = document.querySelector('#reviews-summary-details')
            if(reviewAccordionEle) {
                reviewAccordionEle.setAttribute('open', true)
                scrollToElement(reviewAccordionEle.parentElement, -150)
            }
            // if(reviewAccordionEle) {
            //     reviewAccordionEle.setAttribute('open', true)
            //     reviewAccordionEle.parentElement.scrollIntoView({behavior: 'smooth', block: "start", inline: "nearest"})
            // }
        } else if(panelType == 'openReviewSubmitPanel') {
            panelIsOpen = true;
        }
        // const dialog = document.getElementById('bv-dialog');
        // if (dialog) dialog.showModal();
    }
    function closeDialog() {
        const dialog = document.getElementById('bv-dialog');
        if (dialog) dialog.close();
    }

    function closePanel() {
        panelIsOpen = false;
        panelType = '';
    }

    function openReviewSubmitPanel(e) {
        checkedRatingVal = e.detail.checkedRatingVal
        submitReviewProductCode = e.detail.productCode
        openDialog('openReviewSubmitPanel')
    }

    window.addEventListener('openReviewDialog', function() { openDialog('reviews') });
    window.addEventListener('openQuestionDialog', function() { openDialog('question') });

    window.addEventListener('openReviewSubmitPanel', openReviewSubmitPanel);
    window.addEventListener('hhPanelClose', closePanel, false);
    
    $: {
		const panel = document.querySelector('hh-panel')
		if (panel) panel.hidden = !panelIsOpen;
	}
</script>
<!-- 
<dialog class="Panel" id="bv-dialog" bind:this={dialogEle}>
    <header>
        <h3>{panelType == 'review' ? Strings.ratingsAndReviews : Strings.questionsAndAnswers}</h3>
        <button class="Button ButtonGhost" on:click={closeDialog}>{Strings.close}</button>
    </header>

    {#if panelType == 'review'}
        <ReviewDialog {lang} {productCode} {product} {dialogEle}/>
    {:else if panelType == 'question'}
        <QuestionsDialog {lang} {productCode} />
    {/if}
</dialog> -->

{#if panelType == 'reviews'}
    <Portal target="#pdp-review-section">
        <ReviewPDP {lang} {productCode} {product} />
    </Portal>     
{/if}

{#if getModalType}
    <Portal target="#bz_review_message_portal">
        <dialog bind:this={submitReviewDialogEle}>
            <button on:click={()=> submitReviewDialogEle.close()}><img src="/_icons/icon.close-black.svg" class="Icon Bigger" alt="close email popup icon"></button>

            {#if getModalType == 'already_registered'}
                <section class="review-submit-modal-title">
                    <h3><img src="https://www.homehardware.ca/_icons/Icon_Confirmed.green.svg" alt="success icon" height="24" width="24" style="vertical-align: middle;">
                { en ? "Thank you for your review": "Merci pour votre évaluation"}</h3>
                </section>
                <hr>
                <p class="review-submit-modal-text">{@html en ? "This email address has already<br> been verified." : "Cette adresse courriel a<br> déjà été vérifiée."}</p>
                <hr>
                <section class="review-submit-btn-grp">
                    <button class="Button ButtonSecondary" on:click={()=> submitReviewDialogEle.close()}>{ en ? "Continue Shopping" : "Continuer à magasiner"}</button>
                </section>
            {:else if getModalType == 'success'}
                <section class="review-submit-modal-title">
                    <h3><img src="https://www.homehardware.ca/_icons/Icon_Confirmed.green.svg" alt="success icon" height="24" width="24" style="vertical-align: middle;"> { en ? "Thanks! Your review has been verified.": "Merci! Votre évaluation a été vérifiée."}</h3>
                </section>
                <hr>
                <p class="review-submit-modal-text">{@html en ? "If it meets our community guidelines,<br> we’ll email you once it’s live on HomeHardware.ca." : "Si elle répond aux directives de notre<br> communauté, nous vous enverrons un courriel une<br> fois qu’elle sera en ligne sur homehardware.ca."}</p>
                <hr>
                <section class="review-submit-btn-grp">
                    <button class="Button ButtonSecondary" on:click={()=> submitReviewDialogEle.close()}>{ en ? "Continue Shopping" : "Continuer à magasiner"}</button>
                </section>
            {:else}
                <section class="review-submit-modal-title">
                    <h3><img src="https://www.homehardware.ca/_icons/icon_cancelled.red.svg" alt="Cross icon" height="24" width="24" style="vertical-align: middle;"> { en ? "We couldn’t confirm your review." : "Nous n’avons pas pu confirmer votre évaluation."}</h3>
                </section>
                <hr>
                <p class="review-submit-modal-text">{@html en ? "We couldn't authenticate your email.<br> Your review is still live." : "Nous n’avons pas pu authentifier votre courriel.<br> Votre évaluation est toujours active."}</p>
                <hr>
                <section class="review-submit-btn-grp">
                    <!-- <a class="Button" href={bvOriginalUrl ? window.location.origin + bvOriginalUrl : "#"}>{ en ? "Resend Confirmation" : "Renvoyer la confirmation"}</a> -->
                    <button class="Button ButtonSecondary" on:click={()=> submitReviewDialogEle.close()}>{ en ? "Close" : "Fermer"}</button>
                </section>
            {/if}

        </dialog>
    </Portal>
{/if}

{#if panelIsOpen && panelType == 'openReviewSubmitPanel'}
    <ReviewPanel
        lang = {lang}
        closePanel = {closePanel}
        checkedRatingVal = {checkedRatingVal}
        productCode = {submitReviewProductCode}
    />
{/if}



<style>
    /* Dialog Panel Styles */
    dialog.Panel {
        display: block;
        position: fixed;
        top: 0;
        left: 100%;
        width: min(100%, 500px);
        max-width: min(100%, 500px);
        height: 100vh;
        max-height: none;
        box-sizing: border-box;
        transition: transform .25s ease;
        z-index: +1999 !important;
        overflow-y: auto;
        border-radius: 0;
        padding: 0 !important;
    }
    dialog.Panel:modal {
        transform: translateX(-100%);
    }
    dialog.Panel header {
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        background: rgba(255, 255, 255, .925);
        -webkit-backdrop-filter: blur(5px);
        backdrop-filter: blur(5px);
        padding: var(--gap) !important;
        z-index: +3;
    }
    dialog.Panel > :global(*:not([popover])) {
        padding: var(--gap);
    }
    dialog.Panel > :global(*[data-no-padding-top]) {
        padding: 0 var(--gap);
    }
    /* End Dialog Panel Styles */

</style>